import React, { memo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { TimerIcon, ArrowRightIcon, TagIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
import { haptics } from '../../lib/utils/haptics';
export const EnhancedClearanceSection = memo(function EnhancedClearanceSection() {
  const [searchParams] = useSearchParams();
  const isNowContext = searchParams.get('from') === 'now';
  const {
    scrollContainerRef,
    currentSlide,
    isMobile,
    handleScroll,
    scrollToSlide
  } = useHorizontalScroll();
  const products = [{
    id: 1,
    name: 'Gold Standard Whey - Vanilla',
    brand: 'Optimum Nutrition',
    price: 12.99,
    originalPrice: 59.99,
    discount: 78,
    rating: 4.8,
    reviewCount: 245,
    image: PRODUCT_IMAGES[0],
    stockLeft: 5
  }, {
    id: 2,
    name: 'Pre-Workout - Fruit Punch',
    brand: 'C4',
    price: 9.99,
    originalPrice: 39.99,
    discount: 75,
    rating: 4.6,
    reviewCount: 187,
    image: PRODUCT_IMAGES[1],
    stockLeft: 3
  }, {
    id: 3,
    name: 'Syntha-6 Protein Powder - Chocolate',
    brand: 'BSN',
    price: 14.99,
    originalPrice: 54.99,
    discount: 73,
    rating: 4.7,
    reviewCount: 156,
    image: PRODUCT_IMAGES[2],
    stockLeft: 7
  }, {
    id: 4,
    name: 'ISO100 - Strawberry',
    brand: 'Dymatize',
    price: 15.99,
    originalPrice: 64.99,
    discount: 75,
    rating: 4.9,
    reviewCount: 203,
    image: PRODUCT_IMAGES[3],
    stockLeft: 2
  }, {
    id: 5,
    name: 'Nitro-Tech - Cookies & Cream',
    brand: 'MuscleTech',
    price: 13.99,
    originalPrice: 59.99,
    discount: 77,
    rating: 4.5,
    reviewCount: 134,
    image: PRODUCT_IMAGES[4],
    stockLeft: 4
  }, {
    id: 6,
    name: 'Amino Energy - Blue Raspberry',
    brand: 'Optimum Nutrition',
    price: 8.99,
    originalPrice: 34.99,
    discount: 74,
    rating: 4.4,
    reviewCount: 98,
    image: PRODUCT_IMAGES[0],
    stockLeft: 6
  }];
  const totalSlides = Math.ceil(products.length / 2);
  return <div className="w-full" data-id="element-1896" data-mp="2rd7rnt8alini">
        <div className="container mx-auto px-4" data-id="element-1897" data-mp="2rcfyep263x0e">
          <div className="bg-gradient-to-r from-red-600 to-orange-500 rounded-xl overflow-hidden mb-6" data-id="element-1898" data-mp="2wcke4cv94npk">
            <div className="relative" data-id="element-1899" data-mp="30f79uov1mss1">
              <div className="absolute inset-0 opacity-10" style={{
            backgroundImage: 'url(\'data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="1"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\')'
          }} data-id="element-1900" data-mp="30e5o9qgeinw2"></div>
              <div className="flex flex-col md:flex-row items-center justify-between p-6" data-id="element-1901" data-mp="kqjnjcbum1f9">
                <div className="mb-4 md:mb-0 text-center md:text-left" data-id="element-1902" data-mp="1hgj1jmarps58">
                  <span className="inline-block bg-yellow-400 text-red-800 text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-1903" data-mp="1cgwrflq8ks0n">
                    LAST CHANCE
                  </span>
                  <h2 className="text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-1904" data-mp="18hfjmlnc7isb">
                    CLEARANCE SALE
                  </h2>
                  <p className="text-white text-opacity-90 text-lg" data-id="element-1905" data-mp="3t63bpwxnwtng">
                    Up to 90% off! Once they're gone, they're gone!
                  </p>
                </div>
                <div className="flex flex-col items-center" data-id="element-1906" data-mp="1fxr9uzo7h4h0">
                  <div className="flex items-center bg-white bg-opacity-20 p-3 rounded-lg mb-2" data-id="element-1907" data-mp="1fw7pawvio79f">
                    <TimerIcon className="w-5 h-5 text-white mr-2" data-id="element-1908" data-mp="1kq2bq82ib0c7" />
                    <span className="text-white font-bold" data-id="element-1909" data-mp="16xvvklzcstcr">Ending Soon:</span>
                  </div>
                  <div className="flex space-x-2" data-id="element-1910" data-mp="1azpqseqs555j">
                    <div className="bg-white text-red-600 font-bold rounded-lg w-12 h-12 flex items-center justify-center text-xl relative" data-id="element-1911" data-mp="1awbmv22gwnvz">
                      02
                      <span className="text-xs absolute -bottom-4 text-white" data-id="element-1912" data-mp="23mtnlwfpyd68">
                        Days
                      </span>
                    </div>
                    <div className="bg-white text-red-600 font-bold rounded-lg w-12 h-12 flex items-center justify-center text-xl relative" data-id="element-1913" data-mp="1um5k3vnybv7l">
                      18
                      <span className="text-xs absolute -bottom-4 text-white" data-id="element-1914" data-mp="earw0wj1578d">
                        Hrs
                      </span>
                    </div>
                    <div className="bg-white text-red-600 font-bold rounded-lg w-12 h-12 flex items-center justify-center text-xl relative" data-id="element-1915" data-mp="ap6hy7g4p3bq">
                      45
                      <span className="text-xs absolute -bottom-4 text-white" data-id="element-1916" data-mp="kp77ib4lcfod">
                        Min
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full mb-6" data-id="element-1917" data-mp="3o31hx8bssg4s">
          <div className="container mx-auto px-4" data-id="element-1918" data-mp="3j72ov7fiy9y1">
            {isMobile ? <div className="relative" data-id="element-1919" data-mp="1pjhpoz4y3k9">
                <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3" style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            WebkitOverflowScrolling: 'touch'
          }} data-id="element-1920" data-mp="1ql42pllqcha">
                  {products.map(product => <div key={product.id} className="snap-start flex-shrink-0 relative" style={{
              width: isNowContext ? 'calc(33.333% - 8px)' : 'calc(50% - 6px)'
            }} data-id="element-1921" data-mp="19bi3dghhr5z8">
                      <EnhancedProductCard product={product} data-id="element-1922" data-mp="le2m21faz9rg" />
                      <div className="absolute top-2 right-2 z-20" data-id="element-1923" data-mp="lfvunm9h8423">
                        <div className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full flex items-center whitespace-nowrap" data-id="element-1924" data-mp="qdozaav4sq09">
                          <TagIcon className="w-3 h-3 mr-1" data-id="element-1925" data-mp="ugtz25ntudl7" />
                          Only {product.stockLeft} left
                        </div>
                      </div>
                    </div>)}
                </div>
                <div className="flex justify-center gap-2 mt-4" data-id="element-1926" data-mp="2arxybkjfx0gb">
                  {Array.from({
              length: totalSlides
            }).map((_, index) => <button key={index} onClick={() => scrollToSlide(index)} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-1927" data-mp="2fxunk07dshlf" data-mpi={index} />)}
                </div>
              </div> : <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-1928" data-mp="1x6trbjxnb05k">
                {products.map(product => <div key={product.id} className="relative" data-id="element-1929" data-mp="1sa32o87ryw8j">
                    <EnhancedProductCard product={product} data-id="element-1930" data-mp="1o7gh2p1p67js" />
                    <div className="absolute top-2 right-2 z-20 flex flex-col sm:flex-row gap-1 sm:gap-2" data-id="element-1931" data-mp="3mm1ac5qfrk2b">
                      <div className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full flex items-center whitespace-nowrap" data-id="element-1932" data-mp="3ikpkq07kayu4">
                        <TagIcon className="w-3 h-3 mr-1" data-id="element-1933" data-mp="5p38y10kc00p" />
                        Only {product.stockLeft} left
                      </div>
                    </div>
                  </div>)}
              </div>}
          </div>
        </div>
        <div className="container mx-auto px-4" data-id="element-1934" data-mp="wjuz2xyr2vd">
          <div className="text-center" data-id="element-1935" data-mp="v8v3e7n2f9j">
            <a href="#" className="inline-flex items-center justify-center bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg transition-colors" data-id="element-1936" data-mp="3i5glth7n8b2u">
              View All Clearance Items
              <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-1937" data-mp="3963d4qrcfqj6" />
            </a>
          </div>
        </div>
      </div>;
});